import { useQuery } from "@tanstack/react-query";
import {
  dashboardService,
  type AdminDashboardOverview,
} from "@/services/dashboard/dashboard.service";
import { useAuthStore } from "@/store/use-auth-store";

export function useAdminDashboard(months = 6) {
  const { isAuthenticated, roles } = useAuthStore();

  return useQuery<AdminDashboardOverview>({
    queryKey: ["dashboard", "admin", months],
    queryFn: () => dashboardService.getAdminOverview(months),
    enabled: isAuthenticated && !!roles?.includes("Admin"),
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  });
}
